<template>
  <div id="main-block" class="col-md-6">
    <div id="main-block-status" :class="showMenu === true ? 'col-md-10' : 'col-md-12 mr-2'">
      <h5 v-if="showForbidAccessTitle" id="access">Доступ запрещён</h5>
      <h5 v-if="menuNotEmpty && transportPassIsIssued && isView" id="pass-is-issued">Пропуск выдан</h5>
      <h5 v-if="menuNotEmpty && this.visitor.transports[transportIndex].inScud" id="inSkud" class="pl-2">Передан в СКУД</h5>
    </div>
    <div v-if="menuNotEmpty && showMenu" id="main-block-menu" class="col-md-2">
      <div
        v-if="visitor.access === 0"
        v-click-outside="hide"
        :id="dropDownId"
        class="dropdown application-status-block-button pull-right"
      >
        <a
          :data-toggle="dropDownId"
          class="application-action btn btn-default dropdown-toggle"
          @click="collapse"
        >
          <i class="fa fa-bars"></i>
        </a>
        <ul ref="dropdown" class="dropdown-menu" @click="hide">
          <li>
            <issue-pass-button
              v-if="visibleTransportIssuePassButton && isView"
              title="Выдать пропуск"
              :is-issued="transportPassIsIssued"
              @issue-pass="issuePass()"
            />
            <issue-pass-button
              v-if="visibleTransportIssuePassPeriodButton && isView"
              title="Выдать пропуска"
              :is-issued="transportPassIsIssued"
              @issue-pass="issuePass()"
            />
            <print-pass-button
              v-if="visibleTransportPrintPassButton"
              title="Распечатать пропуск"
              @give-pdf-pass="givePdfPass()"
            />
            <print-pass-button
              v-if="visibleTransportPrintPassPeriodButton"
              title="Распечатать пропуска"
              @give-pdf-pass="givePdfPass(isGivePassPeriod)"
            />
            <print-pass-button
              v-if="visibleTransportPrintPassPermanentAsOneButton"
              title="Выдать разовый пропуск"
              @give-pdf-pass="givePdfPass(isGivePassPeriod, printPermanentAsOne)"
            />
            <print-pass-button
              v-if="visibleTransportPrintPassPermanentButton"
              title="Выдать постоянный пропуск"
              @give-pdf-pass="givePdfPass()"
            />
            <send-to-solvo-button
              v-if="visibleTransportSendToSolvoButton && isView"
              :application-id="form.application.id"
              :personal-id="visitorPersonal.id"
            />
            <give-transport-access-button
              v-if="!visitor.access && visibleCloseButton"
              :visitor="visitor"
              :transport="transport"
              @close-transport="closeTransport()"
            />
            <send-to-scud-button
              v-if="visibleTransportSendToScudButton && isView"
              :in-scud="inScud"
              :application-id="form.application.id"
              :transport-id="transport.id"
              :transport-index="transportIndex"
              :personal-id="visitorPersonal.id"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import applicationFormContextMixin from '../../../../mixins/applicationFormContextMixin'
import mainMixin from '../../../../mixins/mainMixin'
import forceRerenderMixin from '../../../../mixins/forceRerenderMixin'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import sendToSolvoButton from '@/common/components/application/form-blocks/visitors/menu-items/SendToSolvoButton'
import sendToScudButton from '@/common/components/application/form-blocks/visitors/menu-items/SendToScudButton'
import PrintPassButton from '@/common/components/application/form-blocks/visitors/menu-items/PrintPassButton'
import IssuePassButton from '@/common/components/application/form-blocks/visitors/menu-items/IssuePassButton'
import transportsBlockMixin from '@/common/mixins/application-form/transportsBlockMixin'
import GiveTransportAccessButton from '@/common/components/application/form-blocks/transports/menu-items/GiveTransportAccessButton'
import '@/common/assets/styles/visitor-menu-style.scss'
import { UserRoles } from '@/enums/UserRoles'
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames';

export default {
  name: 'TransportFormMenu',

  components: {
    sendToSolvoButton,
    sendToScudButton,
    GiveTransportAccessButton,
    PrintPassButton,
    IssuePassButton
  },

  directives: {
    ClickOutside
  },

  mixins: [
    applicationFormMixin,
    applicationFormContextMixin,
    mainMixin,
    transportsBlockMixin,
    forceRerenderMixin
  ],

  model: {
    prop: 'visitorPersonal',
    event: 'change-visitor'
  },

  props: {
    cfgMenuVisitor: {
      type: [Object, Array],
      default: () => []
    },

    cfgMenuTransport: {
      type: [Object, Array],
      default: () => []
    },

    transport: {
      type: Object,
      required: true
    },

    transportIndex: {
      type: Number,
      required: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    visitorIndex: {
      type: Number,
      required: true
    },

    visitorPersonal: {
      type: Object,
      required: true
    },

    menuNotEmpty: {
      type: Boolean
    }
  },

  data: () => {
    return {
      status: null,
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },

  computed: {
    visibleCloseButton() {
      return Boolean(this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    dropDownId() {
      return `transport-dropdown-${this.visitorIndex}-${this.transportIndex}`;
    },

    getCurrentTransport() {
      return this.visitor.transports[this.transportIndex]
    },

    isGivePassPeriod() {
      return !!this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD]
    },

    printPermanentAsOne() {
      return Boolean(this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE])
    },

    forbidAccess() {
      if (this.visitor.access) {
        return true
      }

      return this.transport.access
    },

    showMenu() {
      return ((
        Array.isArray(this.cfgMenuTransport) === false && (
          this.getCurrentTransport.inScud === 0 || (
            this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] ||
            this.cfgMenuTransport[ConfigMenuNames.SEND_TO_SOLVO]
          )
        )) || this.isView === false || this.visibleCloseButton
      )
    },

    showForbidAccessTitle() {
      return this.isView && this.forbidAccess
    }
  },

  methods: {
    collapse() {
      let el = document.getElementById(this.dropDownId)
      if (el) {
        el.classList.toggle('open')
      }
    },

    hide() {
      let el = document.getElementById(this.dropDownId)
      if (el) {
        el.classList.remove('open')
      }
    },

    async issuePass() {
      const index = this.transportIndex
      const transportId = this.visitor.transports[index].id
      await ApiClient.issuePass({
        visitor_id: this.visitor.personal.id,
        appId: this.form.application.id,
        transportId: transportId
      }).then((result) => {
        if (result && result.data.status === 'success') {
          this.getCurrentTransport.isIssued = true
          this.givePdfPass(this.isGivePassPeriod)
        }
      }).catch(function () {
        alert('Не удалость выдать пропуск.')
      })
    },

    async closeTransport() {
      await ApiClient.changeTransportAccess({
        application_id: this.form.application.id,
        transport_id: this.transport,
        visitor_id: this.visitorPersonal.id
      }).then((response) => {
        if (response?.data?.status === 'success') {
          this.$set(this.transport, 'access', this.transport.access ? 0 : 1)
        }
      })
    }
  }
}
</script>
